import axios from "axios";
import React from 'react';
import {
    basicAuthHeader,
    bearerTokenHeader,
    auditIdHeader,
    externalUserHeader,
    kernoCustomerIdHeader, poolCustomerIdHeader
} from "./auth-service";

export async function getZipCode(cp) {
    const response = await axios.get(process.env.REACT_APP_IP + '/settlements/' + cp,{
        auth: basicAuthHeader()
    });
    return response.data;
}

export async function getMark(year, vType, vUse) {
    let type = null;
    let use = null;
    if (vType === '1' && vUse === '1') {  type = 0; use = 1;}
    if (vType === '2' && vUse === '1') { type = 1; use = 5;}
    const response = await axios.get(process.env.REACT_APP_IP + '/manhattan2/search/makes?yearModel=' + year + '&vType='+type+'&vUse='+use);
    //const response = await axios.get( 'http://52.89.2.42:9091'+'/manhattan2/search/makes?yearModel=' + year + '&vType='+type+'&vUse='+use);
    return response.data;
}

export async function getVersion(year, branch, vType, vUse) {
    let type = null;
    let use = null;
    if (vType === '1' && vUse === '1') {  type = 0; use = 1;}
    if (vType === '2' && vUse === '1') { type = 1; use = 5;}
    const response = await axios.get(process.env.REACT_APP_IP + '/manhattan2/search/vehicles?yearModel=' + year + '&make=' + branch + '&vType='+type+'&vUse='+use);
    //const response = await axios.get('http://52.89.2.42:9091/'+'/manhattan2/search/vehicles?yearModel=' + year + '&make=' + branch + '&vType='+type+'&vUse='+use);
    return response.data;
}

export async function postServiceInsurance(year, branch, model, vType, vUse) {
    let type = null;
    let use = null;
    if (vType === '1' && vUse === '1') {  type = 0; use = 1;}
    if (vType === '2' && vUse === '1') { type = 1; use = 5;}

    //Estructura el form params
    let dataAux = require('querystring');
    const data = new URLSearchParams();
    data.append('year', year);
    data.append('make', branch);
    data.append('model', model);
    data.append('vType', type);
    data.append('vUse', use);

    const response = await axios.post(process.env.REACT_APP_IP + '/manhattan2/search', dataAux.stringify({
    //const response = await axios.post('http://52.89.2.42:9091/v2/manhattan/homologator', dataAux.stringify({
        year: year,
        make: branch,
        model: model,
        vType: type,
        vUse: use,
    }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
    });
    return response.data;
}

export async function postQuotation(quotationModel) {
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader(), externalUserHeader(), kernoCustomerIdHeader());
    const response = await axios.post(process.env.REACT_APP_IP + '/v1/api/asserts/quote', quotationModel, {
       headers: combinedHeaders
    });
    return response.data;
}

export async function postReQuote(movementId) {
    const response = await axios.post(process.env.REACT_APP_IP + '/v1/api/quotes/' + movementId + '/redo', {
        headers: auditIdHeader()
    });
    return response.data;
}

export async function getReQuote(movementId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/quotes/' + movementId + '/recover', {
        headers: auditIdHeader()
    });
    return response.data;
}

//Consult

export async function getListOfQuotes() {
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader(), externalUserHeader(), kernoCustomerIdHeader());
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/quotes',{
        headers: combinedHeaders
    });
    return response.data;
}

export async function getImpresionCotizacionPDF(movementId) {
    let combinedHeaders = Object.assign(bearerTokenHeader(), auditIdHeader(), externalUserHeader(), kernoCustomerIdHeader());
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/quotes/' + movementId + '/print',
        {
            responseType: 'blob',
            headers: combinedHeaders
        });
    return response.data;
}

export async function getClientByEmail(email) {
    const response = await axios.get(process.env.REACT_APP_IP + '/insurancehub/extraction/customers/finder?email=' + email);
    return response.data;
}

export async function getXMLRequestResponseQuotation(movementId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/api/asserts/quote/'+movementId+'/request',
        {
            headers: bearerTokenHeader()
        });
    return response.data;
}
